





























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { TeamMember } from "@/models/team-member.model";
import { BModal, BButton, BBadge, BAlert } from "bootstrap-vue";
import { Position } from "@/models/positions.model";
import positionToVariantFilter from "@/filters/position-to-variant.filter";
import { createSrcSet } from "@/utils/lazysizes.utils";

@Component({
  name: "MyTeamsPlayerCard",
  components: {
    BModal,
    BButton,
    BBadge,
    BAlert
  },
  methods: {
    getInfoClass(position: Position) {
      return "bg-" + positionToVariantFilter(position);
    },
    createSrcSet: createSrcSet
  }
})
export default class MyTeamsPlayerCard extends Vue {
  @Prop({ required: true }) member!: TeamMember;
  @Prop({ required: true, type: Function }) onPlayerClick!: Function;
}
